import { resolveComponent as i, resolveDirective as I, openBlock as s, createElementBlock as g, withDirectives as D, createBlock as h, withCtx as _, Fragment as S, resolveDynamicComponent as M, createCommentVNode as k, createElementVNode as m, toDisplayString as v, createVNode as u, Transition as j, renderList as B, normalizeClass as x, Teleport as V, withModifiers as E, renderSlot as C, createTextVNode as A } from "vue";
import { _ as w } from "./_plugin-vue_export-helper-dad06003.js";
import { V as z, T as U, D as F, M as R, E as q, I as H, a as W, A as G, S as J, b as K, P as Q, c as X } from "./PaintbrushIcon-6981a74e.js";
import { a as Y, B as L } from "./ButtonTertiaryIconMd-3994fc64.js";
import { a as Z, D as $ } from "./DropdownDivider-c57dbbbe.js";
import "./CardVideo-e725a421.js";
import "./glightbox-13d8fc52.js";
import "./FormRichText.model-53e072ea.js";
import { NavbarSidebar as P, NavbarPrimaryItem as N } from "./navbars.js";
import { D as T } from "./DropdownMenu-cf91b06e.js";
import { S as ee } from "./StoreIcon-ab267c80.js";
import { L as te } from "./LoveIcon-2c34d5f1.js";
import { S as oe } from "./ShippingBoxIcon-eeb16070.js";
import { D as ne } from "./DotsHorizontalIcon-41c0040b.js";
import { P as It, a as Dt } from "./PageDropdownButtonSm-b76124c2.js";
import { M as re } from "./MenuRightIcon-eeb404cf.js";
import { B as O } from "./BadgeStatusSm-03be1252.js";
import "./PreloaderIcon-b44be854.js";
import "./CheckIcon-91388c05.js";
import "./HelpIcon-2069ddad.js";
import "./ButtonPlay-d3872713.js";
import "./XIcon-e21df3cc.js";
import "./useNotificationHandler.js";
import "./DownloadFileIcon-8a003268.js";
import "./BarProgressMd-c3ebb73b.js";
import "./ButtonCloseSm-209b27c6.js";
import "./ChevronLeftIcon-b6affe9b.js";
import "./_commonjsHelpers-10dfc225.js";
import "./ChevronDownIcon-461d1eb9.js";
const se = {
  components: {
    ButtonSecondaryMd: Y,
    DropdownList: Z,
    DropdownItem: $,
    ViewDocumentIcon: z
  },
  props: {
    views: {
      type: Array,
      default: () => []
    },
    disabled: Boolean,
    tooltip: {
      type: String,
      default: ""
    },
    modelValue: {
      type: [String, Number],
      default: ""
    },
    hideIcon: Boolean
  },
  emits: ["update:modelValue"],
  data() {
    return {
      showOptions: !1
    };
  },
  computed: {
    notEmptyViews() {
      return this.views.filter((t) => t.label || t.icon);
    },
    selectedOption() {
      return this.views.find((t) => t.value === this.modelValue) || {};
    }
  },
  methods: {
    changeView(t) {
      this.$emit("update:modelValue", t.value), this.hide();
    },
    hide() {
      this.showOptions = !1;
    }
  }
}, ie = { class: "relative" };
function ae(t, o, e, y, r, n) {
  const l = i("ViewDocumentIcon"), p = i("ButtonSecondaryMd"), f = i("DropdownItem"), b = i("DropdownList"), a = I("tooltip"), c = I("click-outside");
  return s(), g("div", ie, [
    D((s(), h(p, {
      disabled: e.disabled,
      onClick: o[0] || (o[0] = (d) => r.showOptions = !r.showOptions)
    }, {
      default: _(() => [
        e.hideIcon ? k("", !0) : (s(), g(S, { key: 0 }, [
          n.selectedOption.icon ? (s(), h(M(n.selectedOption.icon), { key: 1 })) : (s(), h(l, { key: 0 }))
        ], 64)),
        m("span", null, v(n.selectedOption.label), 1)
      ]),
      _: 1
    }, 8, ["disabled"])), [
      [a, { content: e.tooltip }]
    ]),
    u(j, { name: "fade" }, {
      default: _(() => [
        r.showOptions ? D((s(), h(b, {
          key: 0,
          class: "absolute -top-1 left-0 z-20 w-64 transform -translate-y-full"
        }, {
          default: _(() => [
            (s(!0), g(S, null, B(n.notEmptyViews, (d) => (s(), h(f, {
              key: d.value,
              "is-selected": d.value === e.modelValue,
              onClick: (He) => n.changeView(d)
            }, {
              default: _(() => [
                d.icon ? (s(), h(M(d.icon), { key: 0 })) : k("", !0),
                m("span", null, v(d.label), 1)
              ]),
              _: 2
            }, 1032, ["is-selected", "onClick"]))), 128))
          ]),
          _: 1
        })), [
          [c, n.hide]
        ]) : k("", !0)
      ]),
      _: 1
    })
  ]);
}
const bt = /* @__PURE__ */ w(se, [["render", ae]]), le = {
  name: "FormSwitch",
  components: {
    TabletIcon: U,
    DesktopIcon: F,
    MobileIcon: R
  },
  props: {
    modelValue: {
      type: String,
      default: "desktop"
    }
  },
  emits: ["update:modelValue"],
  data() {
    return {
      options: [
        {
          value: "desktop",
          icon: "DesktopIcon"
        },
        {
          value: "tablet",
          icon: "TabletIcon"
        },
        {
          value: "mobile",
          icon: "MobileIcon"
        }
      ]
    };
  },
  computed: {
    selected: {
      get() {
        return this.modelValue;
      },
      set(t) {
        this.$emit("update:modelValue", t);
      }
    }
  }
}, ce = { class: "absolute bottom-6 right-6" }, de = { class: "flex items-center rounded-lg border ct-border-1 shadow-sm shadow-gray-900/5 divide-x divide-gray-300 dark:divide-neutral-700 overflow-hidden" }, ue = ["onClick"];
function me(t, o, e, y, r, n) {
  return s(), g("div", ce, [
    m("div", de, [
      (s(!0), g(S, null, B(r.options, (l, p) => (s(), g("button", {
        key: l.value,
        type: "button",
        class: x(["w-10 h-10 flex items-center justify-center focus:ring-2 focus:ring-inset focus:ct-ring-focus outline-none", [
          l.value === n.selected ? "ct-bg-1 ct-fg-1" : "bg-gray-50 dark:bg-neutral-800 ct-fg-3",
          p === 0 ? "rounded-l-lg" : "",
          p === r.options.length - 1 ? "rounded-r-lg" : ""
        ]]),
        onClick: (f) => n.selected = l.value
      }, [
        (s(), h(M(l.icon)))
      ], 10, ue))), 128))
    ])
  ]);
}
const wt = /* @__PURE__ */ w(le, [["render", me]]), ge = {
  components: {
    EasyLogoIcon: q,
    NavbarSidebar: P,
    DropdownMenu: T
  },
  props: {
    data: {
      type: Object,
      default: () => {
      }
    },
    logoColor: {
      type: String,
      default: ""
    },
    modelValue: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["update:modelValue"],
  computed: {
    showMenu: {
      get() {
        return this.modelValue;
      },
      set(t) {
        this.$emit("update:modelValue", t);
      }
    }
  },
  methods: {
    openDesktopMenu() {
      window.innerWidth > 1024 && (this.showMenu = !0);
    },
    closeDesktopMenu() {
      window.innerWidth > 1024 && (this.showMenu = !1);
    },
    openMenu() {
      var t;
      window.innerWidth > 1024 ? (t = this.data) != null && t.handler ? this.data.handler() : this.showMenu = !0 : this.showMenu = !0;
    }
  }
};
function pe(t, o, e, y, r, n) {
  var b, a;
  const l = i("EasyLogoIcon"), p = i("DropdownMenu"), f = i("NavbarSidebar");
  return s(), g("div", {
    class: "relative",
    onMouseenter: o[2] || (o[2] = (...c) => n.openDesktopMenu && n.openDesktopMenu(...c)),
    onMouseleave: o[3] || (o[3] = (...c) => n.closeDesktopMenu && n.closeDesktopMenu(...c))
  }, [
    u(l, {
      class: x(["cursor-pointer h-10 w-10", {
        "text-cart-400": e.logoColor === "cart",
        "text-love-500": e.logoColor === "love",
        "text-legal-500": e.logoColor === "legal",
        "text-faq-500": e.logoColor === "faq",
        "text-cookie-500": e.logoColor === "cookie",
        "text-timer-500": e.logoColor === "timer",
        "text-player-500": e.logoColor === "player",
        "text-pricing-500": e.logoColor === "pricing",
        "text-coffee-500": e.logoColor === "coffee",
        "text-page-500": e.logoColor === "page",
        "text-banner-500": e.logoColor === "banner",
        "text-ticker-500": e.logoColor === "ticker"
      }]),
      onClick: n.openMenu
    }, null, 8, ["class", "onClick"]),
    u(p, {
      open: n.showMenu,
      "onUpdate:open": o[0] || (o[0] = (c) => n.showMenu = c),
      items: (b = e.data) == null ? void 0 : b.items,
      size: "md"
    }, null, 8, ["open", "items"]),
    (s(), h(V, { to: "body" }, [
      u(f, {
        open: n.showMenu,
        "onUpdate:open": o[1] || (o[1] = (c) => n.showMenu = c),
        items: (a = e.data) == null ? void 0 : a.items
      }, {
        header: _(() => [
          u(l, {
            class: x(["h-10 w-10", {
              "text-cart-400": e.logoColor === "cart",
              "text-love-500": e.logoColor === "love",
              "text-legal-500": e.logoColor === "legal",
              "text-faq-500": e.logoColor === "faq",
              "text-cookie-500": e.logoColor === "cookie",
              "text-timer-500": e.logoColor === "timer",
              "text-player-500": e.logoColor === "player",
              "text-pricing-500": e.logoColor === "pricing",
              "text-coffee-500": e.logoColor === "coffee",
              "text-page-500": e.logoColor === "page",
              "text-banner-500": e.logoColor === "banner",
              "text-ticker-500": e.logoColor === "ticker"
            }])
          }, null, 8, ["class"])
        ]),
        _: 1
      }, 8, ["open", "items"])
    ]))
  ], 32);
}
const fe = /* @__PURE__ */ w(ge, [["render", pe]]), he = {
  components: {
    NavbarPrimaryItem: N,
    DropdownMenu: T,
    ShippingBoxIcon: oe,
    StoreIcon: ee,
    InboxOpenIcon: H,
    TextFlowRowsIcon: W,
    AddLayerIcon: G,
    StarOutlineIcon: J,
    LoveIcon: te,
    MailSendIcon: K,
    PaintbrushIcon: Q
  },
  props: {
    item: {
      type: Object,
      default: () => {
      }
    },
    current: {
      type: String,
      default: ""
    }
  },
  emits: ["update:current"],
  computed: {
    isOpen: {
      get() {
        return this.current === this.item.label;
      },
      set(t) {
        t ? this.$emit("update:current", t) : this.$emit("update:current", "");
      }
    }
  }
}, ye = { class: "relative" };
function _e(t, o, e, y, r, n) {
  const l = i("NavbarPrimaryItem"), p = i("DropdownMenu");
  return s(), g("div", ye, [
    u(l, {
      class: x({ "is-active": e.item.active }),
      onMouseenter: o[0] || (o[0] = (f) => n.isOpen = e.item.label)
    }, {
      default: _(() => [
        (s(), h(M(e.item.icon))),
        m("span", null, v(e.item.label), 1)
      ]),
      _: 1
    }, 8, ["class"]),
    e.item.children && e.item.children.length ? (s(), h(p, {
      key: 0,
      open: n.isOpen,
      "onUpdate:open": o[1] || (o[1] = (f) => n.isOpen = f),
      items: e.item.children,
      size: "md"
    }, null, 8, ["open", "items"])) : k("", !0)
  ]);
}
const be = /* @__PURE__ */ w(he, [["render", _e]]), we = {
  components: {
    NavbarPrimaryItem: N,
    NavbarSidebar: P,
    MenuLeftIcon: X,
    PageCategoryItem: be
  },
  props: {
    items: {
      type: Array,
      default: () => []
    },
    open: {
      type: Boolean,
      default: !1
    },
    current: {
      type: String,
      default: ""
    },
    activeCategories: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: ""
    }
  },
  emits: ["update:open", "update:current", "toggleCategory"],
  data() {
    return {
      closeTimeout: null
    };
  },
  computed: {
    notEmptyItems() {
      return this.items.filter((t) => t.label);
    },
    showCategories: {
      get() {
        return this.open;
      },
      set(t) {
        this.$emit("update:open", t);
      }
    },
    openCategory: {
      get() {
        return this.current;
      },
      set(t) {
        this.$emit("update:current", t);
      }
    }
  },
  watch: {
    activeCategories: {
      immediate: !0,
      handler(t) {
        var o;
        (o = this.items) == null || o.forEach((e) => {
          var y;
          e.active = (y = t[0]) == null ? void 0 : y.includes(e.name), e.active && (e.isOpen = !0), e.children && e.children.forEach((r) => {
            r.active = t[1] ? t[1].includes(r.name) : !1;
          });
        });
      }
    }
  },
  mounted() {
    this.items.forEach((t) => {
      var o;
      t.isOpen = (o = this.activeCategories[0]) == null ? void 0 : o.includes(t.name);
    });
  },
  methods: {
    waitAndClose() {
      this.closeTimeout = setTimeout(() => {
        this.openCategory = "";
      }, 1e3);
    },
    clearClose() {
      clearTimeout(this.closeTimeout);
    }
  }
}, ve = { class: "hidden lg:block xl:hidden" };
function Ce(t, o, e, y, r, n) {
  const l = i("PageCategoryItem"), p = i("MenuLeftIcon"), f = i("NavbarPrimaryItem"), b = i("NavbarSidebar");
  return s(), g(S, null, [
    m("nav", {
      class: "hidden xl:flex items-center space-x-1",
      onMouseleave: o[1] || (o[1] = (...a) => n.waitAndClose && n.waitAndClose(...a)),
      onMouseenter: o[2] || (o[2] = (...a) => n.clearClose && n.clearClose(...a))
    }, [
      (s(!0), g(S, null, B(n.notEmptyItems, (a) => (s(), h(l, {
        key: a.label,
        current: n.openCategory,
        "onUpdate:current": o[0] || (o[0] = (c) => n.openCategory = c),
        item: a,
        onClick: (c) => a.handler ? a.handler() : () => {
        }
      }, null, 8, ["current", "item", "onClick"]))), 128))
    ], 32),
    m("div", ve, [
      u(f, {
        onClick: o[3] || (o[3] = (a) => n.showCategories = !0)
      }, {
        default: _(() => [
          u(p),
          m("span", null, v(e.title), 1)
        ]),
        _: 1
      })
    ]),
    (s(), h(V, { to: "body" }, [
      u(b, {
        open: n.showCategories,
        "onUpdate:open": o[4] || (o[4] = (a) => n.showCategories = a),
        header: e.title,
        items: n.notEmptyItems,
        breakpoint: "xl",
        onToggleCategory: o[5] || (o[5] = (a) => t.$emit("toggleCategory", a))
      }, null, 8, ["open", "header", "items"])
    ]))
  ], 64);
}
const xe = /* @__PURE__ */ w(we, [["render", Ce]]), ke = {
  name: "PageActionsButton",
  components: {
    ButtonTertiaryIconMd: L,
    DotsHorizontalIcon: ne,
    NavbarSidebar: P,
    DropdownMenu: T
  },
  props: {
    actions: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      showActions: !1,
      positionRight: 0
    };
  },
  methods: {
    hide() {
      this.showActions = !1;
    },
    toggleActions() {
      this.positionRight = window.innerWidth - this.$refs.dropdownButton.$el.getBoundingClientRect().right, this.showActions = !this.showActions;
    }
  }
}, Se = { class: "" };
function Me(t, o, e, y, r, n) {
  const l = i("DotsHorizontalIcon"), p = i("ButtonTertiaryIconMd"), f = i("DropdownMenu"), b = i("NavbarSidebar"), a = I("click-outside");
  return s(), g("div", Se, [
    u(p, {
      ref: "dropdownButton",
      onClick: E(n.toggleActions, ["stop"])
    }, {
      default: _(() => [
        u(l)
      ]),
      _: 1
    }, 8, ["onClick"]),
    D(u(f, {
      open: r.showActions,
      "onUpdate:open": o[0] || (o[0] = (c) => r.showActions = c),
      right: "",
      items: e.actions,
      "offset-right": r.positionRight,
      size: "md"
    }, null, 8, ["open", "items", "offset-right"]), [
      [a, n.hide]
    ]),
    (s(), h(V, { to: "body" }, [
      u(b, {
        open: r.showActions,
        "onUpdate:open": o[1] || (o[1] = (c) => r.showActions = c),
        header: e.title,
        items: e.actions
      }, null, 8, ["open", "header", "items"])
    ]))
  ]);
}
const vt = /* @__PURE__ */ w(ke, [["render", Me]]), Ie = {
  components: {
    ButtonTertiaryIconMd: L,
    MenuRightIcon: re,
    BadgeStatusSm: O,
    PageLogoButton: fe,
    PageCategoriesNavigation: xe
  },
  props: {
    activeCategories: {
      type: Array,
      default: () => []
    },
    categories: {
      type: Array,
      default: () => []
    },
    projectName: {
      type: String,
      default: ""
    },
    projectStatus: {
      type: Object,
      default: () => {
      }
    },
    logoData: {
      type: Object,
      default: () => {
      }
    },
    logoColor: {
      type: String,
      default: ""
    },
    categoriesTitle: {
      type: String,
      default: ""
    }
  },
  emits: ["toggleCategory"],
  data() {
    return {
      openLogoMenu: !1,
      openCategory: "",
      showCategories: !1
    };
  },
  computed: {
    hasMiddleSlot() {
      var t;
      return !!((t = this.$slots) != null && t.middle);
    },
    projectStatusType() {
      var t, o;
      return ((t = this.projectStatus) == null ? void 0 : t.type) === "test" ? "orange" : (o = this.projectStatus) == null ? void 0 : o.type;
    },
    activeCategoryLabel() {
      if (this.activeCategories.length > 0) {
        const t = this.categories.find(
          (o) => o.name === this.activeCategories[0]
        );
        return t ? t.label : "";
      }
      return "";
    }
  },
  watch: {
    openCategory(t) {
      t && (this.openLogoMenu = !1);
    },
    openLogoMenu(t) {
      t && (this.openCategory = "");
    }
  }
}, De = { class: "block lg:hidden flex-grow text-center text-sm font-medium ct-text-1" }, Be = { class: "overflow-hidden" }, Ve = { class: "block lg:hidden" }, Pe = { class: "hidden lg:flex items-center space-x-2" }, Te = { class: "text-sm ct-text-2 truncate" };
function Ae(t, o, e, y, r, n) {
  var c;
  const l = i("PageLogoButton"), p = i("PageCategoriesNavigation"), f = i("MenuRightIcon"), b = i("ButtonTertiaryIconMd"), a = i("BadgeStatusSm");
  return s(), g("div", {
    class: x(["sticky top-0 z-30 flex-shrink-0 px-6 h-16 border-b ct-border-2 flex items-center space-x-4", [((c = e.projectStatus) == null ? void 0 : c.type) === "test" ? "bg-warning-100 dark:bg-warning-900" : "ct-bg-1"]])
  }, [
    m("div", {
      class: x(["flex-shrink-0 flex items-center space-x-4", { "lg:flex-grow": !n.hasMiddleSlot }])
    }, [
      u(l, {
        modelValue: r.openLogoMenu,
        "onUpdate:modelValue": o[0] || (o[0] = (d) => r.openLogoMenu = d),
        "logo-color": e.logoColor,
        data: e.logoData
      }, null, 8, ["modelValue", "logo-color", "data"]),
      u(p, {
        current: r.openCategory,
        "onUpdate:current": o[1] || (o[1] = (d) => r.openCategory = d),
        open: r.showCategories,
        "onUpdate:open": o[2] || (o[2] = (d) => r.showCategories = d),
        items: e.categories,
        "active-categories": e.activeCategories,
        title: e.categoriesTitle,
        onToggleCategory: o[3] || (o[3] = (d) => t.$emit("toggleCategory", d))
      }, null, 8, ["current", "open", "items", "active-categories", "title"])
    ], 2),
    C(t.$slots, "middle", {}, () => [
      m("p", De, v(n.activeCategoryLabel), 1)
    ]),
    m("div", Be, [
      m("div", Ve, [
        u(b, {
          onClick: o[4] || (o[4] = (d) => r.showCategories = !0)
        }, {
          default: _(() => [
            u(f)
          ]),
          _: 1
        })
      ]),
      m("div", Pe, [
        m("p", Te, v(e.projectName), 1),
        u(a, {
          class: "flex-shrink-0",
          type: n.projectStatusType
        }, {
          default: _(() => {
            var d;
            return [
              A(v((d = e.projectStatus) == null ? void 0 : d.label), 1)
            ];
          }),
          _: 1
        }, 8, ["type"]),
        C(t.$slots, "default")
      ])
    ])
  ], 2);
}
const Ct = /* @__PURE__ */ w(Ie, [["render", Ae]]), Le = {
  props: {
    showError: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    hasSidebarCta() {
      return this.$slots.sidebarCta;
    },
    hasSidebarFooter() {
      return this.$slots.sidebarFooter;
    }
  }
}, Ne = { class: "flex flex-col h-full" }, Oe = { class: "flex-shrink-0 flex items-center space-x-2 px-6 h-16 border-b ct-border-2" }, je = { class: "overflow-hidden flex-grow ct-text-1 text-lg lg:text-xl" }, Ee = { class: "flex-grow overflow-y-auto no-scrollbar" };
function ze(t, o, e, y, r, n) {
  return s(), g("div", Ne, [
    m("div", Oe, [
      m("p", je, [
        C(t.$slots, "sidebarTitle")
      ]),
      C(t.$slots, "sidebarCta")
    ]),
    m("div", Ee, [
      C(t.$slots, "sidebarMain")
    ]),
    n.hasSidebarFooter ? (s(), g("div", {
      key: 0,
      class: x(["hidden lg:flex ct-bg-1--alt flex-shrink-0 border-t ct-border-2 px-6 items-center", [e.showError ? "h-40 flex-col justify-center space-y-2.5" : "h-16"]])
    }, [
      C(t.$slots, "sidebarFooter")
    ], 2)) : k("", !0)
  ]);
}
const xt = /* @__PURE__ */ w(Le, [["render", ze]]), Ue = {
  components: {
    BadgeStatusSm: O
  },
  props: {
    projectStatus: {
      type: Object,
      default: () => {
      }
    }
  }
}, Fe = { class: "flex lg:hidden fixed bottom-0 inset-x-0 z-30 ct-bg-1--alt border-t ct-border-2 px-5 h-14 items-center justify-between" }, Re = { class: "flex space-x-2" };
function qe(t, o, e, y, r, n) {
  const l = i("BadgeStatusSm");
  return s(), g("div", Fe, [
    u(l, {
      type: e.projectStatus.type
    }, {
      default: _(() => [
        A(v(e.projectStatus.label), 1)
      ]),
      _: 1
    }, 8, ["type"]),
    m("div", Re, [
      C(t.$slots, "default")
    ])
  ]);
}
const kt = /* @__PURE__ */ w(Ue, [["render", qe]]);
export {
  vt as PageActionsButton,
  wt as PageBreakpointsButton,
  xe as PageCategoriesNavigation,
  be as PageCategoryItem,
  It as PageDropdownButton,
  Dt as PageDropdownButtonSm,
  kt as PageFooter,
  Ct as PageHeader,
  fe as PageLogoButton,
  bt as PagePreviewButton,
  xt as PageSidebar
};
